module.exports = __webpack_public_path__ + "static/media/PIBKG_magenta.2227567b.png";